(function ($) {
	const toggleAccordion = function (accordionHeader) {
		const accordion = $(accordionHeader).closest('.accordion');
		const accordionInner = accordion.find('.accordion-inner');
		accordionInner.stop().slideToggle();
		accordion.toggleClass('open');
	};

	// Klick-Handler (bestehend)
	$('.accordion-header').on('click', function () {
		toggleAccordion(this);
	});

	// 🔗 Accordion über URL-Anchor öffnen
	const openAccordionFromHash = function () {
		const hash = window.location.hash;
		if (!hash) return;

		const target = document.querySelector(hash);
		if (!target) return;

		const accordion = target.classList.contains('accordion')
			? target
			: target.closest('.accordion');

		if (!accordion) return;

		// Schon offen? Dann nichts tun
		if (accordion.classList.contains('open')) return;

		const header = accordion.querySelector('.accordion-header');
		if (!header) return;

		// Öffnen mit bestehender Logik
		toggleAccordion(header);

		// Optional: sauber hinscrollen (nachdem es offen ist)
		setTimeout(() => {
			accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}, 300);
	};

	// Beim initialen Laden
	$(document).ready(openAccordionFromHash);

	// Falls innerhalb der Seite auf einen anderen Anchor geklickt wird
	$(window).on('hashchange', openAccordionFromHash);

})(jQuery);
